import { lazy } from "react";

const STORAGE_KEY = "page-has-been-force-refreshed";

const hasAlreadyRefreshed = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "false");
  } catch {
    return false;
  }
};

const markRefreshed = (value) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // ignore storage errors
  }
};

export const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    try {
      const component = await componentImport();
      markRefreshed(false);
      return component;
    } catch (error) {
      const message = String(error?.message || "");
      const isChunkLoadError =
        message.includes("Failed to fetch dynamically imported module") ||
        message.includes("Loading chunk") ||
        message.includes("Importing a module script failed") ||
        message.includes("MIME type");

      if (isChunkLoadError && !hasAlreadyRefreshed()) {
        markRefreshed(true);
        window.location.reload();
        return { default: () => null };
      }

      throw error;
    }
  });
